export class PaymentMethod {


    code: string = '-1'
    title: string
    method_code: string = "-1"
    method_title: string

}
